import { render } from "./TenantSelectionPopup.vue?vue&type=template&id=0fbd2c38&scoped=true"
import script from "./TenantSelectionPopup.vue?vue&type=script&lang=js"
export * from "./TenantSelectionPopup.vue?vue&type=script&lang=js"

import "./TenantSelectionPopup.vue?vue&type=style&index=0&id=0fbd2c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbd2c38"]])

export default __exports__